module.exports = __webpack_public_path__ + "img/5.00201475.jpg";